import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {User} from "../shared/model/user";
import { UserSummaryDto } from '../shared/model/UserSummaryDto';

export const UserActions = createActionGroup({
  source: 'User',
  events: {
    'Get Logged In User': emptyProps(),
    'Set User': props<{ newUser: User | null }>(),
    'UpdateProfileImage': props<{newImage: string}>(),
    'Unset User': emptyProps(),
  }
})

export const UserApiActions = createActionGroup({
  source: 'User API',
  events: {
    'Load User': props<{ userId: number }>,
  }
})

export const LoginUserActions = createActionGroup({
  source: 'User',
  events: {
    'Get Logged In User': emptyProps(),
    'Set User': props<{ newUser: UserSummaryDto | null }>(),
    'UpdateProfileImage': props<{newImage: string}>(),
    'Unset User': emptyProps(),
  }
})
